import { Navigate, Outlet, useLocation } from 'react-router';

import { useAuth } from './useAuth';
import {
    isNavTargetBlockedForUser,
    restrictedRepairerFallbackRoute,
} from './restrictedRepairerRoutes';

/**
 * Story `fe-be-verzekeraar-gebonden-hersteller-chrome-tabs` (EPIC-019 S-C,
 * **beslissing C1**, 2026-08-21) — route-containment voor de
 * verzekeraar-gebonden (beperkte) hersteller. Gespiegeld op
 * {@link ./InsurerRouteGuard InsurerRouteGuard}: één layout-route, één
 * prefix-lijst, geen per-plek-fix.
 *
 * Een beperkte hersteller die op een route van een **verborgen** app landt —
 * via een bookmark, een bel-menu-deeplink (`deepLinkPath` komt onvalideerd van
 * de BE), een credit-doorkliklink, het logo, of een bookmark-redirect uit
 * `routes.tsx` — wordt naar het Glas-dashboard geleid. Dat sluit de vier gaten
 * (N1, N2, N3, N4 uit de TA-review) op **één** plek.
 *
 * Niet-beperkte gebruikers passeren ongemoeid: `isNavTargetBlockedForUser`
 * geeft voor hen per definitie `false`, ongeacht instantie of
 * omgevings-schakelaar. Bij `resolved: false` ("onbekend") verandert er niets —
 * de FE keyt uitsluitend op `active === true`.
 *
 * Eerlijk over de grens (C1): dit stopt **accidentele** toegang, geen script.
 * De echte handhaving zijn de BE-poorten; daarom blijft de omgevings-schakelaar
 * op productie `false` tot S-F en S-G live zijn (beslissing C5).
 */
export function RestrictedRepairerRouteGuard() {
    const { user } = useAuth();
    const location = useLocation();

    if (isNavTargetBlockedForUser(user, location.pathname)) {
        return <Navigate to={restrictedRepairerFallbackRoute(user)} replace />;
    }

    return <Outlet />;
}
